import React, { useState, useEffect, useContext, useRef } from 'react';

import styles from 'components/layout_and_quote_builder/_style.module.scss';
import LayoutNavSectionCombination from 'components/layout_and_quote_builder/LayoutNavSectionCombination.jsx';

const LayoutNavSectionCombinationListList = ({ list, count, setSelectedList }) => {
  const [totalScore, setTotalScore] = useState(0)
  const [totalScoreList, setTotalScoreList] = useState({})
  const [numTotals, setNumTotals] = useState( {} )
  const [numTotalsPrinting, setNumTotalsPrinting] = useState( {} )
  const [numOfDrawingsInSet, setNumOfDrawingsInSet] = useState( {} )

  const handleClick = () => {
    setSelectedList( list )
  }

  const showNavSectionCombination = ( result, index ) => {
    return <LayoutNavSectionCombination
      index = {index}
      diecutting_result={result.diecutting_result}
      nav_section_id={result.nav_section_id}
      count={count}
      layout_dimension={result.material_layout_dimension}
      setTotalScoreList={setTotalScoreList}
      setNumTotals={setNumTotals}
      setNumTotalsPrinting={setNumTotalsPrinting}
      setNumOfDrawingsInSet={setNumOfDrawingsInSet}
    />
  }

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_total_diecutting = numTotals[i]
      list[i].num_total_printing   = numTotalsPrinting[i]
    }
  }, [numTotals, numTotalsPrinting] )


  useEffect( () => {
    setTotalScore( () => Object.values(totalScoreList).reduce((a, b) => a + b, 0)  )
  }, [totalScoreList])

  useEffect( () => {
    for(let i = 0; i < list.length; i++ ) {
      list[i].num_of_drawings_in_set = numOfDrawingsInSet[i]
    }
  }, [numOfDrawingsInSet] )

  return (
    <div className={styles.combinations_grid_item_cont} key={name} data-score={totalScore} onClick={handleClick}>
      <div style={{fontSize: '12px' }} className="stars-rating-container"></div>

      {list.map((result, index) => (
        <React.Fragment key={index}>
          {showNavSectionCombination(result, index)}
        </React.Fragment>
      ))}
    </div>
  )
}

export default LayoutNavSectionCombinationListList;
